import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Label, Input, FormFeedback } from 'reactstrap';
import moment from 'moment';

import api from "../../../api";
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaDatePicker from "../../../components/ParadigmaDatePicker/ParadigmaDatePicker"
import CurrencyInput from "../../../components/ParadigmaCurrencyInput/ParadigmaCurrencyInput.js"
import { formatCurrency } from './../../functions/dateFunctions.js'

const parseMontoFloat = (x) => (parseFloat(((x.toString()).replace(/[.]/g, '')).replace(',', '.')));

class Delete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fecha: moment(),
            cuentaCorriente: null,
            categoria: null,
            unidadVinculacionTecnologica: null,
            ingreso: '0',
            egreso: '0',
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    setSelects(data) {
        this.setState({
            fecha: moment(data.fecha),
            cuentaCorriente: data.cuenta_corriente_id,
            categoria: data.categoria_id,
            unidadVinculacionTecnologica: data.unidad_vinculacion_tecnologica_id,
            ingreso: formatCurrency(data.ingreso_monto),
            egreso: formatCurrency(data.egreso_monto),
        });
    }

    render() {
        const {
            fecha,
            cuentaCorriente,
            categoria,
            unidadVinculacionTecnologica,
            ingreso,
            egreso,
        } = this.state

        return (
            <ParadigmaModal
                getUrl={api.saldos.movimientos.delete}
                postUrl={api.saldos.movimientos.delete}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Movimiento ha sido eliminado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Eliminar Movimiento"}
                buttonTitle={"Eliminar Movimiento"}
                buttonIcon={"fa fa-trash fa-lg"}
                
                saveButton={true}
                closeButton={true}
                danger={true}
                buttonClass={"btn-danger"}
                saveButtonLabel={"Eliminar"}
                className={"ui-modal-dialog ui-modal-lg"}
                onGotData={(data) => this.setSelects(data)}
            >
                <div className="ui-form">
                    <section className="ui-section-block">
                        <p className="ui-section-label">Datos del movimiento</p>
                        <div className="ui-section-grid">
                            <div className="ui-field">
                                <Label>Fecha</Label>
                                <ParadigmaDatePicker disabled={true} fieldName={"fecha"} datetime={false} monthpicker={false} value={fecha} />
                            </div>
                            <div className="ui-field">
                                <Label>Cuenta Corriente</Label>
                                <ParadigmaAsyncSeeker disabled={true} fieldName={"cuenta_corriente"} nombreField={"subgrupo_nombre"} url={api.saldos.cuentasCorrientes.selectRestringido} value={cuentaCorriente} />
                            </div>
                            <div className="ui-field">
                                <Label>Categoria</Label>
                                <ParadigmaAsyncSeeker disabled={true} fieldName={"categoria"} url={api.saldos.categorias.select} value={categoria} />
                            </div>
                            <div className="ui-field">
                                <Label>UVT</Label>
                                <ParadigmaAsyncSeeker disabled={true} fieldName={"unidad_vinculacion_tecnologica"} url={api.proyectos.config.presupuesto.uvt.select} value={unidadVinculacionTecnologica} />
                            </div>
                            <div className="ui-field ui-section-span-2">
                                <Label>Factura</Label>
                                <Input disabled={true} type="text" name="factura"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                            <div className="ui-field ui-section-span-2">
                                <Label>Descripción</Label>
                                <Input disabled={true} type="textarea" rows={4} name="descripcion"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                    </section>
                    <section className="ui-section-block">
                        <p className="ui-section-label">Importes</p>
                        <div className="ui-row-2">
                            <div className="ui-field">
                                <Label>Ingreso ($)</Label>
                                <Fragment>
                                    <CurrencyInput disabled={true} placeholder='0' className='monto' selectOnFocus={true} maskOptions={{ includeThousandsSeparator: true, allowLeadingZeroes: true }} value={ingreso} />
                                    <Input type="hidden" name={"ingreso_monto"} value={parseMontoFloat(ingreso)} />
                                    <FormFeedback className="col-12"></FormFeedback>
                                </Fragment>
                            </div>
                            <div className="ui-field">
                                <Label>Egreso ($)</Label>
                                <Fragment>
                                    <CurrencyInput disabled={true} placeholder='0' className='monto' selectOnFocus={true} maskOptions={{ includeThousandsSeparator: true, allowLeadingZeroes: true }} value={egreso} />
                                    <Input type="hidden" name={"egreso_monto"} value={parseMontoFloat(egreso)} />
                                    <FormFeedback className="col-12"></FormFeedback>
                                </Fragment>
                            </div>
                        </div>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <Label>Observación</Label>
                                <Input disabled={true} type="textarea" rows={4} name="observacion"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                    </section>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Delete;



// WEBPACK FOOTER //
// ./src/views/Saldos/Movimientos/Delete.js